<div class="carousel-swiper-container">
  <div class="carousel-prev carousel-button" (click)="scrollPrev()" *ngIf="hasOverflow" [class.swiper-button-disabled]="isAtStart">
    <mat-icon>chevron_left</mat-icon>
  </div>

  <div #scrollContainer class="scroll-container" (scroll)="onScroll()">
    <!-- Primeiros 3 produtos -->
    <div class="align-adjust">
      <div class="discount-badge" [style.height.px]="discountBadgeHeight"></div>
      <div class="products-container">
        <ng-container *ngFor="let item of items.slice(0, 3); let i = index">
          <ng-container *ngTemplateOutlet="slideTemplate; context: { $implicit: item, index: i}"></ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Container agrupado com fundo rosa para os itens restantes -->
    <div class="highlight-wrapper align-adjust">
      <div class="discount-badge" #discountBadge>
        <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.65632 17.8356L0.497986 9.6773V11.344C0.497986 11.7856 0.672986 12.2106 0.989652 12.519L7.48132 19.0106C8.13132 19.6606 9.18965 19.6606 9.83965 19.0106L15.0147 13.8356C15.6647 13.1856 15.6647 12.1273 15.0147 11.4773L8.65632 17.8356Z" fill="#E63888"/>
          <path d="M7.48132 14.844C7.80632 15.169 8.23132 15.3356 8.65632 15.3356C9.08132 15.3356 9.50632 15.169 9.83132 14.844L15.0063 9.66897C15.6563 9.01897 15.6563 7.96063 15.0063 7.31063L8.51465 0.818966C8.20632 0.510632 7.78132 0.335632 7.33965 0.335632H2.16465C1.24799 0.335632 0.497986 1.08563 0.497986 2.0023V7.1773C0.497986 7.61897 0.672986 8.04397 0.989652 8.3523L7.48132 14.844ZM2.16465 2.0023H7.33965L13.8313 8.49397L8.65632 13.669L2.16465 7.1773V2.0023Z" fill="#E63888"/>
          <path d="M4.03965 4.91897C4.61495 4.91897 5.08132 4.4526 5.08132 3.8773C5.08132 3.302 4.61495 2.83563 4.03965 2.83563C3.46436 2.83563 2.99799 3.302 2.99799 3.8773C2.99799 4.4526 3.46436 4.91897 4.03965 4.91897Z" fill="#E63888"/>
        </svg>
        <p class="discount-badge-text">Pacotes com desconto progressivo nas consultas!</p>
      </div>
      <div class="products-container">
        <ng-container *ngFor="let item of items.slice(3); let i = index">
          <ng-container *ngTemplateOutlet="slideTemplate; context: { $implicit: item, index: i + 3 }"></ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="carousel-next carousel-button" (click)="scrollNext()" *ngIf="hasOverflow" [class.swiper-button-disabled]="isAtEnd">
    <mat-icon>chevron_right</mat-icon>
  </div>
</div>
